import React from 'react';

/**
 * 登录 / 授权页专用的图标。
 *
 * 没有沿用 @ant-design/icons：那套是描边风格、视觉重量比设计稿轻一档，
 * 混在这两个页面里一眼就能看出「和稿子不一样」。这里按稿子重画成实心，
 * 统一 16 视窗、fill=currentColor，颜色和大小完全由外面的 CSS 决定。
 */
type IconProps = {
  size?: number;
  className?: string;
};

const Glyph: React.FC<IconProps & { path: string }> = ({ path, size = 15, className }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
  >
    <path d={path} />
  </svg>
);

export const UserGlyph: React.FC<IconProps> = (props) => (
  <Glyph
    {...props}
    path="M8 8a3 3 0 100-6 3 3 0 000 6zm0 1.5c-2.7 0-5.5 1.35-5.5 3v1.25h11V12.5c0-1.65-2.8-3-5.5-3z"
  />
);

export const LockGlyph: React.FC<IconProps> = (props) => (
  <Glyph
    {...props}
    path="M12 6.5h-.75V5a3.25 3.25 0 10-6.5 0v1.5H4A1 1 0 003 7.5v6a1 1 0 001 1h8a1 1 0 001-1v-6a1 1 0 00-1-1zM6.25 5a1.75 1.75 0 013.5 0v1.5h-3.5V5z"
  />
);

export const ChevronGlyph: React.FC<IconProps> = (props) => (
  <Glyph {...props} path="M6 3.5L10.5 8 6 12.5l-1-1L8.5 8 5 4.5z" />
);

export const PlusGlyph: React.FC<IconProps> = (props) => (
  <Glyph {...props} path="M8.75 3.5h-1.5V7.25H3.5v1.5h3.75V12.5h1.5V8.75h3.75v-1.5H8.75z" />
);

export const MailGlyph: React.FC<IconProps> = (props) => (
  <Glyph
    {...props}
    path="M2.5 4h11a.5.5 0 01.5.5v.35L8 8.55 2 4.85V4.5a.5.5 0 01.5-.5zM2 6.03V11.5a.5.5 0 00.5.5h11a.5.5 0 00.5-.5V6.03L8 9.72z"
  />
);

export const SwapGlyph: React.FC<IconProps> = (props) => (
  <Glyph
    {...props}
    path="M4.9 1.9L1.6 5.2l3.3 3.3 1.06-1.06L4.42 5.9H11V4.5H4.42l1.54-1.54zM11.1 7.5l3.3 3.3-3.3 3.3-1.06-1.06 1.54-1.54H5v-1.4h6.58l-1.54-1.54z"
  />
);

export const CheckGlyph: React.FC<IconProps> = (props) => (
  <Glyph {...props} path="M6.4 11.3L3.2 8.1l1.1-1.1 2.1 2.1 5.3-5.3 1.1 1.1z" />
);

export const LogoutGlyph: React.FC<IconProps> = (props) => (
  <Glyph
    {...props}
    path="M6.5 2.5h-3A1.5 1.5 0 002 4v8a1.5 1.5 0 001.5 1.5h3V12H3.5V4h3V2.5zm3.35 2.15l-1.06 1.06L10.19 7.25H6v1.5h4.19l-1.4 1.54 1.06 1.06L14 8l-4.15-3.35z"
  />
);

export const InfoGlyph: React.FC<IconProps> = (props) => (
  <Glyph {...props} path="M8 1a7 7 0 100 14A7 7 0 008 1zm.75 10.5h-1.5V7h1.5v4.5zm0-6h-1.5V4h1.5v1.5z" />
);

export const WarnGlyph: React.FC<IconProps> = (props) => (
  <Glyph {...props} path="M8 1a7 7 0 100 14A7 7 0 008 1zm.75 10.5h-1.5V10h1.5v1.5zm0-3h-1.5V4h1.5v4.5z" />
);
